import LogoDiadWhite from "../../assets/logodiadunjbgwhite.png";
import { Button, message } from "antd";
import { MenuOutlined, PoweroffOutlined } from "@ant-design/icons";
import { logout } from "../../api/auth";
import { useHistory } from "react-router-dom";
import * as SHARED from "../../utils/shared";

const handleLogout = () => {
  message.info("Se ha finalizado la sesión");
  logout();
  window.location.reload();
};

/**
 * LayoutParticipanteHeader
 * @param {Object} user
 * @param {Function} showDrawer
 * @param {String} titulo
 * @returns
 */
function LayoutParticipanteHeader(props) {
  const { showDrawer = null } = props;
  const history = useHistory();

  return (
    <header
      className="flex justify-between items-center w-full h-16 p-4"
      style={{ background: "#D41D3D" }}
    >
      <div className="flex items-center flex-shrink-0">
        {showDrawer && (
          <span className="mr-4 md:hidden">
            <button onClick={showDrawer}>
              <MenuOutlined className="text-white" />
            </button>
          </span>
        )}
        <button onClick={() => history.push("/")}>
          <img src={LogoDiadWhite} width={150} alt="Logo DIAD-UNJBG" />
        </button>
      </div>
      <h1 className="hidden md:block text-white font-semibold text-base flex-shrink-0">
        {SHARED.NOMBRE_SISTEMA} - {SHARED.PROCESO}
      </h1>
      <div className="flex-shrink-0">
        <Button onClick={handleLogout} type="white">
          <PoweroffOutlined /> Cerrar sesión
        </Button>
      </div>
    </header>
  );
}

export default LayoutParticipanteHeader;
